import type { EvalCriterionDto } from "../../../autogen/bff-api";

/**
 * How a scorable row is named outside the evaluation grid.
 *
 * The grid can group sub-criteria under a heading, but everywhere else — the rationale form, the award
 * letter — a row appears on its own, and "Tilbudt nøkkelpersonell" means little without the criterion it
 * belongs to. Top-level rows are unchanged.
 */
export const evalCriterionOwnLabel = (criterion: EvalCriterionDto, typeLabel: string): string =>
  criterion.name || typeLabel;

export const evalCriterionLabel = (criterion: EvalCriterionDto, typeLabel: string): string => {
  const own = evalCriterionOwnLabel(criterion, typeLabel);
  return criterion.parentName ? `${criterion.parentName} — ${own}` : own;
};

/**
 * The weight to quote for a scorable row: its share of the WHOLE procurement.
 *
 * `weightPercent` is the weight as typed, which for a sub-criterion is a share of its parent — quoting
 * that in an award letter would overstate what the criterion actually counted for. So it stands in for a
 * missing effective weight only on a top-level row, where the two are the same number by definition; a
 * sub-criterion row without one is quoted weightless rather than with a share of the wrong whole.
 */
export const evalCriterionWeightPercent = (criterion: EvalCriterionDto): number | null | undefined =>
  criterion.parentId != null
    ? criterion.effectiveWeightPercent
    : (criterion.effectiveWeightPercent ?? criterion.weightPercent);
